import type { AssetTimelineInterventionDetailsProps } from "./asset-timeline-intervention-details.type";

import { Row, Typography, Spin } from "antd";
import { useTranslation } from "react-i18next";

import {
  getInterventionTypeAndSubType,
  useInterventionType,
} from "@/entities/referential/referential-intervention-types";
import ButtonLink from "@/modules/button-link";
import { useCauserSubjectLink } from "@/modules/causer-subject";

const { Title, Text } = Typography;

export const AssetTimelineInterventionDetails = ({
  assetEvent,
}: AssetTimelineInterventionDetailsProps) => {
  const { t } = useTranslation();

  const { types: interventionTypes = [] } = useInterventionType();
  const { subject } = assetEvent;

  const route = useCauserSubjectLink("intervention", subject);

  if (!subject?.id) return null;

  const { interventionType, interventionSubType } =
    getInterventionTypeAndSubType(subject, interventionTypes);

  return (
    <div className="intervention-item-details">
      <Row>
        <Title level={4}>{subject.name}</Title>
      </Row>
      {interventionType ? (
        <Row className="intervention-type">
          <Text strong>{interventionType.name}</Text>
          {interventionSubType && (
            <>
              <Text>{">"}</Text>
              <Text>{interventionSubType.name}</Text>
            </>
          )}
        </Row>
      ) : (
        <Spin />
      )}
      <Row>
        <Text>{subject.description}</Text>
      </Row>
      {route && (
        <Row className="intervention-item-actions">
          <ButtonLink type="text" to={route}>
            {t("asset:timeline.goToIntervention")}
          </ButtonLink>
        </Row>
      )}
    </div>
  );
};
